import { render, staticRenderFns } from "./ContractCategory.vue?vue&type=template&id=18ff2c2a"
import script from "./ContractCategory.vue?vue&type=script&lang=js"
export * from "./ContractCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports